<template>
	<div>
		<el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>酒店管理</el-breadcrumb-item>
			<el-breadcrumb-item>酒店列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin: 15px; min-height: calc(100vh - 111px)">
			<div>
				<!--    功能区-->
				<div style="margin: 10px 0">
					<!--    搜索区-->
					<div style="margin: 10px 0">
						<el-input v-model="search" clearable placeholder="请输入酒店名称" prefix-icon="Search"
							style="width: 20%" />
						<el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"></el-button>
						<el-button icon="refresh-left" style="margin-left: 10px" type="default"
							@click="reset"></el-button>
						<div style="float: right">
							<el-tooltip content="添加" placement="top">
								<el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
							</el-tooltip>
						</div>
					</div>
				</div>
				<!--    表格-->
				<el-table v-loading="loading" :data="tableData" border max-height="705" style="width: 100%">
					<el-table-column label="ID" prop="id" width="100px" />
					<el-table-column label="酒店名称" prop="name" />
					<el-table-column label="价格" prop="projectName" />
					<el-table-column label="有效日期" width="300">
						<template #default="scope">
							<el-tag v-if="formatDateRange(scope.row.obtainingTime)" type="info" size="small">
								{{ formatDateRange(scope.row.obtainingTime) }}
							</el-tag>
							<span v-else>未设置日期</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="190px">
						<template #default="scope">
							<el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
							<el-button icon="Delete" type="danger" @click="handleDelete(scope.row.id)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--分页-->
				<div style="margin: 10px 0">
					<el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]"
						:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<!--      弹窗-->
				<div>
					<el-dialog v-model="dialogVisible" title="操作" width="50%" @close="cancel">
						<el-form ref="form" :model="form" :rules="rules" label-width="120px">
							<el-form-item label="酒店名称" prop="name" style="margin-bottom: 27px">
								<el-input v-model="form.name" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="价格" prop="projectName" style="margin-bottom: 27px">
								<el-input v-model="form.projectName" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="日期范围" prop="dateRange" style="margin-bottom: 27px">
								<el-date-picker
									v-model="form.dateRange"
									type="daterange"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									format="YYYY-MM-DD"
									value-format="YYYY-MM-DD"
									:shortcuts="dateShortcuts"
									style="width: 80%"
								/>
							</el-form-item>
						</el-form>
						<template #footer>
							<span class="dialog-footer">
								<el-button @click="cancel">取 消</el-button>
								<el-button type="primary" @click="save">确 定</el-button>
							</span>
						</template>
					</el-dialog>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import request from "@/utils/request";
	import E from "wangeditor";
	import { formatDate, parseDate } from "element-plus";

	const {
		ElMessage
	} = require("element-plus");
	
	export default {
		name: "BuildingInfo",
		components: {
			E,
		},
		data() {
			return {
				author: "",
				loading: true,
				disabled: false,
				judge: false,
				dialogVisible: false,
				detailDialog: false,
				search: "",
				currentPage: 1,
				pageSize: 10,
				total: 0,
				tableData: [],
				nameData: [],
				projectNameData: [],
				detail: {},
				// 新增：景点列表数据
				attractionsList: [],
				
				// 日期快捷选项 - 修改为从开始日期往后推
				dateShortcuts: [
					{
						text: '今天',
						value: () => {
							const today = new Date();
							return [today, today];
						}
					},
					{
						text: '本周',
						value: () => {
							const today = new Date();
							// 本周的开始日期（周日为第一天）
							const startOfWeek = new Date(today);
							startOfWeek.setDate(today.getDate() - today.getDay());
							// 本周的结束日期
							const endOfWeek = new Date(today);
							endOfWeek.setDate(today.getDate() + (6 - today.getDay()));
							return [startOfWeek, endOfWeek];
						}
					},
					{
						text: '本月',
						value: () => {
							const today = new Date();
							// 本月的第一天
							const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
							// 本月的最后一天
							const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
							return [startOfMonth, endOfMonth];
						}
					},
					{
						text: '未来一周',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setDate(today.getDate() + 7);
							return [start, end];
						}
					},
					{
						text: '未来一月',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setMonth(today.getMonth() + 1);
							return [start, end];
						}
					},
					{
						text: '未来三月',
						value: () => {
							const today = new Date();
							const start = new Date(today);
							const end = new Date(today);
							end.setMonth(today.getMonth() + 3);
							return [start, end];
						}
					}
				],
				
				form: {
					name: "",
					projectName: "",
					dateRange: [], // 修改为日期范围数组
					state: "",
					// 新增：关联景点ID数组
					attractionIds: []
				},
				rules: {
					name: [{
						required: true,
						message: "请输入酒店名称",
						trigger: "blur"
					}],
					projectName: [{
						required: true,
						message: "请输入价格",
						trigger: "blur"
					}],
					dateRange: [{
						required: true,
						message: "请选择日期范围",
						trigger: "change"
					}],
				},

			};
		},
		created() {
			this.getSessionInfo();
			this.load();
			this.loadAttractions(); // 新增：加载景点列表
			this.loading = true;
			setTimeout(() => {
				//设置延迟执行
				this.loading = false;
			}, 1000);
		},
		mounted() {},
		methods: {
			// 格式化日期范围显示
			formatDateRange(dateRangeStr) {
				if (!dateRangeStr) return '';
				try {
					const dateArray = dateRangeStr.split(',');
					if (dateArray.length === 2) {
						return `${dateArray[0]} 至 ${dateArray[1]}`;
					} else if (dateArray.length === 1) {
						return dateArray[0];
					}
					return dateRangeStr;
				} catch (error) {
					console.error("格式化日期范围出错:", error);
					return dateRangeStr;
				}
			},
			
			// 获取本周的开始和结束日期
			getWeekRange(date = new Date()) {
				const today = new Date(date);
				const day = today.getDay();
				
				// 计算本周第一天（周日为0，周一为1，依此类推）
				const firstDayOfWeek = new Date(today);
				firstDayOfWeek.setDate(today.getDate() - day);
				
				// 计算本周最后一天
				const lastDayOfWeek = new Date(today);
				lastDayOfWeek.setDate(today.getDate() + (6 - day));
				
				return {
					start: firstDayOfWeek,
					end: lastDayOfWeek
				};
			},
			
			// 获取本月的开始和结束日期
			getMonthRange(date = new Date()) {
				const today = new Date(date);
				const year = today.getFullYear();
				const month = today.getMonth();
				
				// 本月的第一天
				const firstDayOfMonth = new Date(year, month, 1);
				
				// 本月的最后一天
				const lastDayOfMonth = new Date(year, month + 1, 0);
				
				return {
					start: firstDayOfMonth,
					end: lastDayOfMonth
				};
			},
			
			// 获取指定天数的未来日期
			getFutureDate(startDate, days) {
				const date = new Date(startDate);
				date.setDate(date.getDate() + days);
				return date;
			},
			
			// 获取指定月数的未来日期
			getFutureMonth(startDate, months) {
				const date = new Date(startDate);
				date.setMonth(date.getMonth() + months);
				return date;
			},
			
			async load() {
				request.get("/signup/find", {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log(res);
					this.tableData = res.data.records;
					this.total = res.data.total;
					this.loading = false;
				});
			},
			// 新增：加载景点列表方法
			async loadAttractions() {
				request.get("/publicize/find", {
					params: {
						pageNum: 1,
						pageSize: 100, // 获取足够多的景点
						search: "",
					},
				}).then((res) => {
					console.log("景点列表", res);
					this.attractionsList = res.data.records;
				});
			},
			reset() {
				this.search = ''
				request.get("/signup/find", {
					params: {
						pageNum: 1,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log(res);
					this.tableData = res.data.records;
					this.total = res.data.total;
					this.loading = false;
				});
			},
			getSessionInfo() {
				let user = JSON.parse(sessionStorage.getItem("user"));
				this.author = user.name;
			},
			cancel() {
				this.$refs.form.resetFields();
				this.dialogVisible = false;
			},
			add() {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					this.disabled = false;
					this.form = {
						name: "",
						projectName: "",
						dateRange: [], // 重置为空的日期范围
						state: "",
						// 新增：初始化景点ID数组
						attractionIds: []
					};
					this.judge = false;
				});
			},
			save() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						// 复制表单数据，避免直接修改原始数据
						const requestData = {
							...this.form
						};
						
						// 处理日期范围：将数组转换为逗号分隔的字符串
						if (Array.isArray(requestData.dateRange) && requestData.dateRange.length === 2) {
							// 将日期范围数组转换为逗号分隔的字符串格式
							requestData.obtainingTime = requestData.dateRange.join(',');
						} else {
							// 如果没有选择日期范围，清空原来的字段
							requestData.obtainingTime = '';
						}
						
						// 删除临时的dateRange字段，避免后端接收错误
						delete requestData.dateRange;

						// 将 attractionIds 数组转换为逗号分隔的字符串
						if (Array.isArray(requestData.attractionIds)) {
							requestData.attractionIds = requestData.attractionIds.join(',');
						}

						if (this.judge === false) {
							//新增
							request.post("/signup/add", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "新增成功",
										type: "success",
									});
									this.search = "";
									this.loading = true;
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						} else {
							//修改
							request.put("/signup/update", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "修改成功",
										type: "success",
									});
									this.search = "";
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						}
					}
				});
			},
			handleEdit(row) {
				//修改
				this.judge = true;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					// 深拷贝
					const rowData = JSON.parse(JSON.stringify(row));
					
					// 处理日期范围：将后端返回的字符串转换为数组
					if (rowData.obtainingTime && typeof rowData.obtainingTime === 'string') {
						const dateArray = rowData.obtainingTime.split(',');
						if (dateArray.length === 2) {
							rowData.dateRange = [dateArray[0], dateArray[1]];
						} else if (dateArray.length === 1 && dateArray[0]) {
							// 如果只有一个日期，设置为相同开始和结束日期
							rowData.dateRange = [dateArray[0], dateArray[0]];
						} else {
							rowData.dateRange = [];
						}
					} else {
						rowData.dateRange = [];
					}
					
					// 保留原始obtainingTime字段，避免表单验证失败
					rowData.obtainingTime = row.obtainingTime;
					
					// 新增：处理景点ID数据
					if (rowData.attractionIds && typeof rowData.attractionIds === 'string') {
						// 如果后端返回的是字符串格式，转换为数组
						rowData.attractionIds = rowData.attractionIds.split(',').map(id => parseInt(id));
					} else if (!rowData.attractionIds) {
						// 如果没有景点ID数据，初始化为空数组
						rowData.attractionIds = [];
					}

					this.form = rowData;
					this.disabled = true;
				});
			},
			handleDelete(id) {
				console.log(id);
				request.delete("/signup/delete/" + id).then((res) => {
					if (res.code === "0") {
						ElMessage({
							message: "删除成功",
							type: "success",
						});
						this.search = "";
						this.load();
					} else {
						ElMessage({
							message: res.msg,
							type: "error",
						});
					}
				});
			},
			handleSizeChange(pageSize) {
				//改变每页个数
				this.pageSize = pageSize;
				this.load();
			},
			handleCurrentChange(pageNum) {
				//改变页码
				this.currentPage = pageNum;
				this.load();
			},
		},
	};
</script>

<style scoped>
	/* 可以添加一些自定义样式 */
	.el-tag {
		font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
	}
	
	.el-date-editor--daterange.el-input__wrapper {
		border-radius: 4px;
	}
	
	.el-date-editor--daterange.el-input__wrapper:hover {
		border-color: #409eff;
	}
	
	.el-date-editor--daterange.el-input__wrapper.is-focus {
		border-color: #409eff;
		box-shadow: 0 0 0 1px #409eff inset;
	}
</style>